module.exports = __webpack_public_path__ + "bcb72380de5498f8fbddd15aad2bdc96.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/history/9.jpg
// module id = 281
// module chunks = 0